import React, { useEffect } from "react";
import HeroBanner from "../../components/DynamicHero";
import LatestNews from "../../components/recents";
import { setMetaTag, setPropertyMetaTag } from "../../helpers/seoUtils";
import { useTranslation } from "react-i18next";

const News = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Latest News – Economus";

    setMetaTag(
      "description",
      "Stay updated with the latest news, projects, and developments from Economus, your trusted playground experts in Lithuania."
    );
    setMetaTag(
      "keywords",
      "Economus news, playground updates, Lithuania, latest projects, vaikų žaidimų aikštelės naujienos"
    );
    setMetaTag("robots", "index, follow");
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Latest News – Economus");
    setMetaTag(
      "twitter:description",
      "Explore recent updates and exciting developments from Economus."
    );
    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");

    setPropertyMetaTag("og:title", "Latest News – Economus");
    setPropertyMetaTag(
      "og:description",
      "Updates on our latest playground installations, safety innovations, and partnerships."
    );
    setPropertyMetaTag("og:url", "https://economus.netlify.app/recents");
    setPropertyMetaTag("og:type", "website");
  }, []);

  return (
    <>
      <HeroBanner text={t("navTranslate.recents")} />
      <LatestNews />
    </>
  );
};

export default News;
